import React, { useState } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';

export default function PrimeiroAcessoReducedForm({ onSuccess }) {
  const [anoInvestidura, setAnoInvestidura] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    if (!anoInvestidura || !/^\d{4}$/.test(String(anoInvestidura))) {
      setIsSubmitting(false);
      return setError('Informe o ano de investidura válido (ex: 2024).');
    }

    try {
      await api.post('/ano-investidura', { ano_investidura: String(anoInvestidura) });
      toast.success('Ano de investidura salvo com sucesso!');
      setTimeout(() => onSuccess && onSuccess(), 1200);
    } catch (err) {
      setError(err.response?.data?.message || 'Ocorreu um erro ao salvar o ano de investidura.');
      toast.error(err.response?.data?.message || 'Ocorreu um erro ao salvar o ano de investidura.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5" aria-label="Formulário ano de investidura">
      <div>
        <label htmlFor="ano_investidura" className="block text-sm font-medium text-gray-700">Ano de Investidura</label>
        <input
          type="text"
          name="ano_investidura"
          id="ano_investidura"
          value={anoInvestidura}
          onChange={(e) => setAnoInvestidura(e.target.value.replace(/\D/g, ''))}
          maxLength={4}
          className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="2024"
          required
          aria-label="Ano de Investidura"
        />
      </div>
      {error && (
        <div className="text-red-500 text-sm text-center pt-2" aria-live="assertive">{error}</div>
      )}
      <button
        type="submit"
        disabled={isSubmitting}
        className={`w-full py-2 px-4 rounded-lg transition duration-300 ${isSubmitting ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
        aria-label="Salvar Ano de Investidura"
      >
        {isSubmitting ? 'Salvando...' : 'Salvar Ano'}
      </button>
    </form>
  );
}
